import { Suspense, useState } from "react";
import { Outlet } from "react-router-dom";
import { I18nProvider } from "../_metronic/i18n/i18nProvider";
import { LayoutProvider, LayoutSplashScreen } from "../_metronic/layout/core";
import { MasterInit } from "../_metronic/layout/MasterInit";
import { AuthInit, getAuth } from "./modules/auth";
import { requestPassword } from "./modules/auth/core/_requests";
import { getError } from "./modules/helpers/errors";

const App = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [msg, setMessage] = useState<string>("");
  const data: any = getAuth();
  const tryFetchUser = async () => {
    try {
      if (!data?.email) return;
      setMessage("");
      setIsLoading(true);

      await requestPassword(data?.email);

      setMessage("Please check your email for password reset instructions");
    } catch (ex: any) {
      setMessage(getError(ex));
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <Outlet />

            <div className="modal fade" tabIndex={-1} id="change_password">
              <div className="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="d-flex justify-content-center p-3">
                      <span className="fs-3">
                        Are you sure you want to change your password? We'll
                        send you a link to follow the instructions.
                      </span>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancel!
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      disabled={isLoading}
                      onClick={tryFetchUser}
                    >
                      {isLoading ? "Processing..." : "Send me link!"}
                    </button>
                    <div>{msg}</div>
                  </div>
                </div>
              </div>
            </div>

            <MasterInit />
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  );
};

export { App };
